export default "__VITE_ASSET__B3cnDFsz__"